import { useTranslation } from "react-i18next";
import { Row, Tab, Tabs } from "react-bootstrap";
import data from "../../../data";
import { FlowImage } from "../../FlowImage";

function FlowVKIVIU() {
  const { t } = useTranslation();
  return (
    <>
      <div className="tkdn-container-definition">
        <div className="tkdn-section-header">
          <div className="border-title-vpti" />
          <h1 className="tkdn-section-title">{t("vkiviu_flow.title")}</h1>
        </div>
        <div>
          <Row>
            <Tabs defaultActiveKey={1} id="controlled-tab-example">
              {Array.from(data.vkiviu_flow.flow, (item, i) => {
                return (
                  <Tab
                    eventKey={i + 1}
                    title={t(`vkiviu_flow.flow.${i}.title`)}
                  >
                    <FlowImage
                      mobile_file_src={`/images/VKIVIU/${item.title}-mobile`}
                      desktop_file_src={`/images/VKIVIU/${item.title}`}
                    />
                  </Tab>
                );
              })}
            </Tabs>
          </Row>
        </div>
      </div>
    </>
  );
}
export default FlowVKIVIU;
